<template>
	<div :class="cardClasses" :id="card.cardID" :style="{ minHeight: containerHeight}">
		<div class="qr-code-container">
			<img class="qr-display" :src="`data:image/png;base64,${card.qrCode}`">
			<div class="moving-bar-container">
				<span class="moving-bar"></span>
			</div>
		</div>

		<div class="card-infos">
			<div class="card-info card-number" v-show="card.cardNumber">
				<span class="info-label">{{ $t('cards.card.cardNumberLabel') }}</span>{{ card.cardNumber }}
			</div>
			<!-- <div class="card-info full-name" v-show="card.firstName || card.surName || validity">
				<div class="name-container">
					<span class="info-label first-name" v-show="card.firstName">{{ card.firstName }}</span>
					<span class="info-label last-name" v-show="card.surName">{{ card.surName }}</span>
				</div>
				<span class="validity" v-show="validity">{{ validity }}</span>
			</div> -->
		</div>

		<div :class="{ 'has-thumbnail': card.image, 'card-details': true}">
			<!-- <div class="details-title">Details</div> -->
			<div class="thumbnail" v-if="card.image">
				<img :src="`data:${card.imageType};base64,${card.image}`" alt="card.imageName">
			</div>
			<div class="details">
				<div class="card-detail registered-to" v-show="card.firstName || card.surName">
					<div class="detail-label">{{ $t('cards.card.registeredToLabel') }}</div>
					<div class="name-container thinner-font">
						<strong>
							<span class="first-name" v-show="card.firstName">{{ card.firstName }}</span>
							<span class="last-name" v-show="card.surName">{{ card.surName }}</span>
						</strong>
					</div>
					<div class="card-detail date-of-birth" v-show="birthDateFormatted">
						<div class="detail-label">{{ $t('cards.card.dateBirthLabel') }}</div>
						<div class="birth-date-container thinner-font"><strong>{{ birthDateFormatted }}</strong></div>
					</div>
					<div class="email-container thinner-font">
						{{ card.email }}
					</div>
				</div>
			</div>
		</div>

		<div class="card-packages">
			<div class="details">
				<div class="card-detail booked-packages" v-if="card.servicePackages && card.servicePackages.length >= 1">
					<div class="detail-label">{{ $t('cards.card.bookedPackagesLabel') }}</div>
					<div class="booked-package thinner-font" v-for="(service, index) in card.servicePackages.slice(0, 3)" :key="`${index}-package`">
						{{ service }}
					</div>
				</div>
				<div class="card-detail valid-until" v-show="false">
					<div class="detail-label">{{ $t('cards.card.validUntilLabel') }}</div>
					<div class="valid-until thinner-font">{{ validUntil }}</div>
				</div>
			</div>
		</div>
		
		<div class="my-card-actions">
			<a class="button expanded" hre="https://google.at" target="_blank" rel="nofollow noopener" v-if="card.myCardDeeplink" :href="card.myCardDeeplink">
				<span class="btn-icon"><font-awesome-icon :icon="['fal', 'id-card']" size="2x" /></span>
				<span class="btn-text">{{ $t('cards.buttons.myCardLink') }}</span>
			</a>
			<button type="button" class="btn-register-card button expanded" @click="navToRegistration">
				<span class="btn-icon"><font-awesome-icon :icon="['fal', 'credit-card']" size="2x" /></span>
				<span class="btn-text">{{ $t('cards.buttons.registerCard') }}</span>
			</button>
			<button type="button" class="btn-revalidate-card button expanded" @click="openPinRequest">
				<span class="btn-icon"><font-awesome-icon :icon="['fal', 'sync']" :spin="isUpdating" size="2x" /></span>
				<span class="btn-text">{{ $t('cards.card.reValidateLabel') }}</span>
			</button>
			<button type="button" class="btn-remove-card button expanded" @click="removeCard(card.cardID)">
				<span class="btn-icon"><font-awesome-icon :icon="['fal', 'times']" size="2x" /></span>
				<span class="btn-text">{{ $t('cards.buttons.removeCard') }}</span>
			</button>
		</div>

		<div :class="{'pin-request': true, 'show-pin-request': showPinRequest}">
			<div class="request-content">
				<label class="input-label" for="pin">
					<input id="pin" name="pin" type="text" placeholder="PIN" v-model="pin" :class="{ 'not-valid': pinNotValid, 'valid': !pinNotValid}">
					<span :class="{ 'pin-error validation-error': true, 'show-error': pinNotValid }">{{ $t('cards.registration.pinNotValid') }}</span>
				</label>
				<button type="button" class="btn-register button" @click="revalidateCard">{{ $t('cards.card.reValidateLabel') }}</button>
				<button type="button" class="btn-close-pin-request button hollow alert" @click="closePinRequest">
					{{ $t('cancel') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'Card',
		props: {
			card: {
				type: Object,
				default: () => { return {} }
			},
			index: {
				type: Number,
				default: -1
			}
		},
		data () {
			return {
				cardClasses: [
					'card',
					'card-' + this.card.cardID
				],
				isUpdating: false,
				showPinRequest: false,
				pinNotValid: false,
				pin: '',
				containerHeight: '500px'
			}
		},
		computed: {
			/* modifiedDeeplink () {
				let wrongLink = this.card.myCardDeeplink // https://card.feratel.com/cardwebshop2/kcs01/default/
				let correctLink = wrongLink.replace('https://card.feratel.com/cardwebshop2/kcs01/default/', 'https://card-webshop.feratel.com/kcs01/default/') // https://card-webshop.feratel.com/kcs01/default/
				return correctLink
			}, */
			validity () {
				if (this.card && this.card.dateTo) {
					let to = moment(this.card.dateTo)
					return to.format('MM/YY')
				} else {
					return undefined
				}
			},
			validUntil () {
				if (this.card && this.card.dateTo) {
					let to = moment(this.card.dateTo)
					to.locale(this.$i18n.locale)
					return to.format('DD. MMMM YYYY')
				} else {
					return undefined
				}
			},
			birthDateFormatted () {
				if (this.card && this.card.dateBirth) {
					let birthDate = moment(this.card.dateBirth)
					return birthDate.format('DD.MM.YYYY')
				} else {
					return undefined
				}
			}
		},
		methods: {
			navToRegistration () {
				this.$router.push({ name: 'my-card-register' })
			},
			removeCard (id) {
				this.$store.dispatch('removeCard', id)
				this.$emit('removed-card', this.index)
				this.$notify({
					group: 'registration',
					text: this.$t('cards.registration.removeSuccess'),
					ignoreDuplicates: true
				})
			},
			packageID(name) {
				return name
					.replace(' ', '')
					.replace('ä', 'ae')
					.replace('ß', 'ss')
					.toLowerCase()
			},
			revalidateCard () {
				if (this.pin !== '') {
					this.showPinRequest = false;
					this.isUpdating = true
					this.$store.dispatch('registerCard', { cardNumber: this.card.cardNumber, cardPin: this.pin })
						.then((result) => {
							if (result === 'UPDATED_CARD') {
								this.$notify({
									group: 'registration',
									text: this.$t('cards.registration.updateSuccess')
								})
							}
							this.isUpdating = false
							this.pin = ''
						})
						.catch((error) => {
							console.log(error)
							this.isUpdating = false
							this.pin = ''
							this.$notify({
								group: 'registration',
								text: this.$t('cards.registration.invalidCredentials')
							})
						})
				}
			},
			openPinRequest () {
				this.showPinRequest = true
			},
			closePinRequest () {
				this.showPinRequest = false
			},
		},
		watch: {
			pin (pin) {
				if (pin.match(/[0-9a-zA-Z]{4,}/g) && pin.length <= 25) {
					this.pinNotValid = false
				} else {
					this.pinNotValid = true
				}	
			}
		},

		mounted(){ // Otti: Check if user is online and time since last card update is <5h. If so, check and update card information
			this.card.myCardDeeplink
			if (navigator.onLine) {
				let lastCardUpdate = new Date (this.card.lastCardUpdate)
				let nextCardUpdate = new Date (lastCardUpdate.getTime()+18000000)		// Otti: Card Update interval is 5 h = 18000000 ms or manual via button
				let currentTime = moment().toDate()

				if (nextCardUpdate.getTime() < currentTime.getTime()) {
					//console.log('time for an card update...')
					this.pin = this.card.cardPin
					this.revalidateCard();
				} else {
					//console.log('no need for an card update')
				}
			} else {
				//console.log("user offline")
			}
		}
	}
</script>

<style lang="scss">
	@keyframes pending {
		0% {
			transform: translateX(0%);
		}
		
		50% {
			transform: translateX(100%);
		}
		
		100% {
			transform: translateX(0%);
		}
	}
	@keyframes shrinkGrow {
		0% {
			width: 1rem;
		}
		50% {
			width: 4rem;
		}
		100% {
			width: 1rem;
		}
	}
</style>

<style lang="scss">
	.card{
		position: relative;
		display: flex;
		flex-direction: column;
		max-width: rem-calc(500);
		margin: 0 auto !important;
		.qr-code-container{
			position: relative;
			margin-bottom: 1rem;
			padding-top: 1rem;
			padding-bottom: 1rem;
			background-color: $white;
			overflow: hidden;

			.qr-display{
				display: block;
				margin: 0 auto;
				max-width: 70%;
			}
			.moving-bar-container{
				position: absolute;
				bottom: .25rem;
				left: .25rem;
				width: calc(100% - 1.5rem);
				animation: pending 5s infinite;

				.moving-bar{
					display: block;
					width: 4rem;
					height: .325rem;
					border-radius: 20rem;
					background-color: #FFE477;

					animation: shrinkGrow 2.5s infinite;
				}
			}
		}

		.card-infos{
			.card-info{
				&.card-number{
					font-size: rem-calc(18);
					font-weight: 700;
				}

				&.full-name{
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 1rem;
					color: $dark-gray;
					font-weight: 300;

					.last-name{
						justify-self: flex-start;
					}
					.validity{
						opacity: .5;
					}
				}

				.info-label{
					&:first-child{
						margin-right: .5rem;
					}
				}
			}
			margin-bottom: 1rem;
		}

		.card-details, .card-packages {
			@include xy-grid();
			@include xy-gutters($gutter-position: top bottom);
			@include xy-gutters($gutter-type: padding, $gutter-position: top left bottom right);
			margin-bottom: 1rem;
			margin-top: 0;
			background-color: rgba($white, .3);
			border-radius: .35rem;

			.details-title{
				@include xy-cell(12, false, 0);
				margin-bottom: 1rem;
				color: get-color(primary);
				font-weight: bold;
			}

			.email-container{
				word-break: break-word;
			}

			.details, .packages{
				@include xy-cell(12, false, 0);
				
				.card-detail{
					&:not(:last-child){
						//margin-bottom: rem-calc(20);
					}
					.detail-label{
						font-size: rem-calc(12);
						font-weight: 600;
						text-transform: uppercase;

						.thinner-font{
							font-weight: 300;
						}
					}
					.name-container{
						.first-name{
							padding-right: .5rem;
						}
					}
				}
			}

			&.has-thumbnail{
				.thumbnail{
					@include xy-cell(4, false, 0);
					text-align: center;

					img{
						display: inline-block;
						width: 100%;
						height: auto;
						border-radius: .3rem;
						border: 1px solid $medium-gray;
					}
				}
				.details{
					@include xy-cell(8, false, 0);
					padding-left: 1rem;
				}
			}
		}

		.my-card-actions{
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			align-items: center;
			align-self: flex-end;
			margin-top: auto;
			margin-bottom: 2rem;

			.button{
				display: flex;
				justify-content: flex-start;
				align-items: center;
				border-radius: 20rem;
				padding-left: 1.5rem;
				padding-right: 1.5rem;

				&.btn-revalidate-card{
					margin-bottom: 2rem;
				}

				&.btn-remove-card{
					@include button(
						true,
						#E9722A,
						scale-color(#E9722A, $lightness: -15%),
						$white,
						'solid'
					);
					display: flex;
					justify-content: flex-start;
					align-items: center;
					padding-left: 1.5rem;
					padding-right: 1.5rem;
					border-radius: 20rem;
				}

				.btn-icon{
					width: 15%;

					@include breakpoint(small only) {
						svg{
							font-size: 1.15rem;
						}
					}
				}
				.btn-text{
					text-align: left;
					text-transform: uppercase;
				}
			}
		}

		.pin-request{
			position: absolute;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: get-color(secondary);
			left: 0;
			right: 0;
			bottom: 0;
			padding-top: 2rem;
			padding-bottom: 2rem;
			transform: translate(0, 100%);
			visibility: hidden;
			opacity: 1;
			transition: all .2s ease-in-out;
			border: 1px solid scale-color(get-color(secondary), $lightness: -5%);
			border-bottom: 0;
			box-shadow: 0px -2px 3px rgba($black, .15);
			border-bottom: none;
			border-top-left-radius: .35rem;
			border-top-right-radius: .35rem;

	
			&.show-pin-request{
				visibility: visible;
				opacity: 1;
				z-index: 200;
				transform: translate(0, 0);
			}
	
			.request-content{
				@include xy-gutters($gutter-type: padding, $gutter-position: top left bottom right);
				background-color: $white;
				border-radius: .35rem;

				.input-label{
					input{
						border: none;
						border-bottom: 1px dashed $dark-gray;
						background-color: transparent;
						box-shadow: none;

						&.not-valid{
							color: get-color(alert);
							&:placeholder{
								color: get-color(alert);
							}
						}
					}

					.validation-error {
						display: block;
						text-align: right;
						font-size: rem-calc(12);

						visibility: hidden;
						opacity: 0;
						transform: translate(0, 100%);
						transition: all .2s ease-in-out;

						&.show-error {
							visibility: visible;
							opacity: 1;
							transform: translate(0,0);
						}
					}
				}

				.btn-register,
				.btn-close-pin-request{
					display: block;
					margin: 0 auto;
					margin-top: 2rem;
					border-radius: 20rem;
					box-shadow: 0px 1px 2px rgba($black, .15);
				}
				.btn-close-pin-request{
					margin-top: 1rem;
				}
			}
		}
	}
</style>
